import { Routes } from '@angular/router';
import { authGuard, SPECTRUM_HELP_ROUTES } from 'common';

export const routes: Routes = [
    {
        path: 'validate',
        loadComponent: () => import('./validate/validate.component').then(m => m.ValidateComponent)
    },
    {
        path: '',
        canActivate: [authGuard],
        loadComponent: () => import('./layout/screens.component').then(m => m.ScreensComponent),
        children: [
            // The Help centre: this module's manual and Getting around Spectrum.
            ...SPECTRUM_HELP_ROUTES,
            { path: '', redirectTo: 'overview', pathMatch: 'full' },
            {
                path: 'overview',
                loadComponent: () => import('./screens/overview/overview.component').then(m => m.OverviewComponent)
            },
            {
                path: 'users',
                loadComponent: () => import('./screens/users/users.component').then(m => m.UsersComponent)
            },
            {
                path: 'roles',
                loadComponent: () => import('./screens/roles/roles.component').then(m => m.RolesComponent)
            },
            {
                path: 'inspector',
                loadComponent: () => import('./screens/inspector/inspector.component').then(m => m.InspectorComponent)
            },
            {
                path: 'review',
                loadComponent: () => import('./screens/review/review.component').then(m => m.ReviewComponent)
            },
            {
                path: 'audit',
                loadComponent: () => import('./screens/audit/audit.component').then(m => m.AuditComponent)
            }
        ]
    },
    { path: '**', redirectTo: '' }
];
